var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 40184"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.4993 3.66608H8.54297",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.63038 3.66608H1.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M19.5001 9.86847H17.1523",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M13.2389 9.86847H1.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M19.4994 16.0718H6.19531",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M2.28259 16.0718H1.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M6.58698 5.99205C5.93742 5.99205 5.41309 5.47255 5.41309 4.829V2.50289C5.41309 1.85934 5.93742 1.33984 6.58698 1.33984C7.23653 1.33984 7.76087 1.85934 7.76087 2.50289V4.829C7.76087 5.47255 7.23653 5.99205 6.58698 5.99205Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M15.1954 12.1949C14.5458 12.1949 14.0215 11.6754 14.0215 11.0319V8.70578C14.0215 8.06222 14.5458 7.54272 15.1954 7.54272C15.8449 7.54272 16.3693 8.06222 16.3693 8.70578V11.0319C16.3693 11.6754 15.8449 12.1949 15.1954 12.1949Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M4.23932 18.3396C3.58977 18.3396 3.06543 17.8201 3.06543 17.1765V14.8504C3.06543 14.2069 3.58977 13.6874 4.23932 13.6874C4.88887 13.6874 5.41321 14.2069 5.41321 14.8504V17.1765C5.41321 17.8201 4.88887 18.3396 4.23932 18.3396Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSetting);
export default __webpack_public_path__ + "static/media/ic_setting.21005502cff2d258316640f5cbd9301e.svg";
export { ForwardRef as ReactComponent };